import { Component, inject } from '@angular/core';
import { AppConfig } from '@app/core/app.config';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
    selector: 'material-tooltip',
    templateUrl: './material-tooltip.component.html',
    styleUrls: ['./material-tooltip.component.scss'],
    standalone: false
})
export class MaterialTooltipComponent implements ITooltipAngularComp {
  protected readonly GRID_EMPTY_VALUE = inject(AppConfig).GRID_EMPTY_VALUE;
  public params: any;

  public agInit(params: ITooltipParams): void {
    this.params = params;
  }
}
